export default __webpack_public_path__ + "vamos-a-pescar-logo-9e5a048cad9311e5fb90b3424f186b83.png";